import React, { useMemo } from 'react';
import {
  superAdminSideBarNavigations,
  patientSideBarNavigations,
  specialistSideBarNavigations,
  adminSideBarNavigations,
  patientAdminSideBarNavigations,
  supportAdminSideBarNavigations,
  SideBarNavigationInterface,
  hospitalPocSideBarNavigations,
  specialistAdminSideBarNavigations,
  financeAdminSideBarNavigations,
} from '@/constants';
import {useAppRoute, useRole, useWindowDimensions} from '@/hooks';
import {useNavigate} from 'react-router-dom';
import {Text, Icon, Modal} from '@/ui-kits';
import {Logo} from '../logo';
import {cn} from '@/utils/common_functions';
import {screenSize} from '@/theme';

interface SideBarProps {
  open?: boolean;
  onClose?: () => void;
}
export const SideBar: React.FC<SideBarProps> = props => {
  const {open, onClose} = props;
  const {
    isSuperAdmin,
    isSpecialist,
    isPatient,
    isPatientAdmin,
    isHospitalPoc,
    isSupportAdmin,
    isSpecialistAdmin,
    isFinanceAdmin,
  } = useRole();
  const {width} = useWindowDimensions();

  
  const sideBarOptions = useMemo(() => {
    if (isSuperAdmin) {
      return superAdminSideBarNavigations;
    }
    if (isPatientAdmin) {
      return patientAdminSideBarNavigations;
    }
    if (isSupportAdmin) {
      return supportAdminSideBarNavigations;
    }
    if (isSpecialistAdmin) {
      return specialistAdminSideBarNavigations;
    }
    if (isFinanceAdmin) {
      return financeAdminSideBarNavigations;
    }
    if (isSpecialist) {
      return specialistSideBarNavigations;
    } 
    if (isPatient) {
      return patientSideBarNavigations;
    }
    if (isHospitalPoc) {
      return hospitalPocSideBarNavigations;
    }
    return adminSideBarNavigations;
  }, [isSuperAdmin, isPatientAdmin, isSupportAdmin, isSpecialistAdmin, isFinanceAdmin, isSpecialist, isPatient, isHospitalPoc]);

  const sideBarContent = (
    <>
      <div className="mb-6">
        <Logo />
      </div>
      {sideBarOptions.map(item => (
        <SideNavItem {...item} key={item.label} onClose={onClose} />
      ))}
    </>
  );

  // Show as modal for tablet and below (xl breakpoint and below)
  if (width < screenSize['xl']) {
    return (
      <Modal
        className="h-full bg-transparent"
        open={open || false}
        onClose={() => onClose?.()}>
        <div 
          className="h-full fixed top-0 left-0 max-w-[50%] w-full bg-white p-4 flex flex-col gap-4"
          onClick={(e) => e.stopPropagation()}>
          {sideBarContent}
        </div>
      </Modal>
    );
  }
  return (
    <div className="bg-white py-4 px-8 gap-6 flex flex-col h-full border-r w-[280px] border-ui_input_border">
      {sideBarContent}
    </div>
  );
};

interface SideNavItemProps extends SideBarNavigationInterface {
  onClose?: () => void;
}

const SideNavItem: React.FC<SideNavItemProps> = props => {
  const {activeIcon, icon, label, route, onClose} = props;
  const {isActive} = useAppRoute({check: route});
  const navigate = useNavigate();

  function handleClick() {
    navigate(route);
    onClose?.();
  }

  return (
    <button
      onClick={handleClick}
      className={cn([
        'flex gap-2 items-center p-2 rounded-lg overflow-hidden',

        isActive && 'bg-gradient-to-r from-ui_blue to-ui_blue_light',
      ])}>
      <Icon className="size-[18px]" type={isActive ? activeIcon : icon} />
      <Text
        className={cn([
          'text-ui_blue text-nowrap text-base font-FigtreeSemiBold',
          isActive && 'text-white',
        ])}>
        {label}
      </Text>
    </button>
  );
};
